"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoModalLayout = exports.VideoModalLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var video_player_1 = require("../elements/video-player");
var coalesce_1 = require("../../utils/coalesce");
var video_size_1 = require("../../utils/video-size");
exports.VideoModalLayoutDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #000;\n    box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    ", ";\n  "], ["\n    background: #000;\n    box-shadow: 0 0 15px -7px rgba(0,0,0,0.7);\n    ", ";\n  "])), (0, video_size_1.videoSize)(320)),
  landscape: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), (0, video_size_1.videoSize)(400)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), (0, video_size_1.videoSize)(640)),
  desktop: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), (0, video_size_1.videoSize)(980))
});
var VideoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Video: (0, styled_components_1.default)(video_player_1.VideoPlayer)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), VideoStyles)
};
var VideoModalLayout = function (props) {
  var className = props.className,
    entity = props.entity;
  var url = (0, coalesce_1.coalesce)(entity, ['url', 'openGraph.url']);
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Video, {
    playing: true,
    url: url,
    config: {
      controlsList: "nodownload"
    }
  }), ";");
};
exports.VideoModalLayout = VideoModalLayout;
exports.VideoModalLayout.defaultProps = exports.VideoModalLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;